import { getStorage, ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { app } from '../config/firebase';

const storage = getStorage(app);

/**
 * Uploads a file to Firebase Storage and returns its download URL.
 * @param file The file to upload.
 * @param path The path where the file should be stored in Firebase Storage (e.g., 'collaborator-documents').
 * @param onProgress Optional callback to report upload progress.
 * @returns The download URL of the uploaded file.
 */
export const uploadFile = (
    file: File,
    path: string,
    onProgress?: (progress: number) => void
): Promise<string> => {
    console.log(`[uploadFile] Attempting to upload '${file.name}' to path: '${path}'`);
    return new Promise((resolve, reject) => {
        const storageRef = ref(storage, path);
        const uploadTask = uploadBytesResumable(storageRef, file);

        uploadTask.on(
            'state_changed',
            (snapshot) => {
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                if (onProgress) {
                    onProgress(progress);
                }
            },
            (error) => {
                console.error('Upload failed:', error);
                reject(error);
            },
            () => {
                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                    resolve(downloadURL);
                });
            }
        );
    });
}; 